export default {
	APP: 'AppLayout',
	SALES: 'SalesLayout',
	BLANK: 'BlankLayout',
};
